import { BreadcrumbItem as ChakraBreadcrumbItem } from '@chakra-ui/react';
import { ChevronRightIcon } from '../../components/icons';

export type BreadcrumbItemProps = {
    separator?: string | React.ReactElement;
    isLastChild?: boolean;
    spacing?: string | number;
    children: React.ReactNode;
};

export const BreadcrumbItem = ({
    separator,
    spacing,
    isLastChild,
    children,
}: BreadcrumbItemProps): JSX.Element => (
    <ChakraBreadcrumbItem separator={separator} spacing={spacing} isLastChild={isLastChild}>
        {children}
    </ChakraBreadcrumbItem>
);

BreadcrumbItem.defaultProps = {
    separator: <ChevronRightIcon style={{ verticalAlign: 'middle' }} />,
    isLastChild: false,
    spacing: '8px',
};
